import styled from 'styled-components';

export const CurrentConditionsBodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-decoration: none;
    height: 65%;
    width: 100%;
`;
